/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/LeaveManagement/AllLeaveRequests.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { MdPreview } from "react-icons/md";
import { HiDownload } from "react-icons/hi";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import axios from "axios";
import {
  Apiurl,
  GetLoginRole,
  GetToken,
  formatNoOfDays,
  downloadFile,
} from "../../../Utils/utils";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import dummyimage from "../../../Assets/Images/dummyimg.png";

const ReadMoreText = ({ text, maxLength = 45 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return <span>-</span>;

  const shouldTrim = text.length > maxLength;

  return (
    <div className="approval-reason-text-wrap">
      <span className="approval-reason-text">
        {shouldTrim && !expanded ? `${text.slice(0, maxLength)}...` : text}
      </span>

      {shouldTrim && (
        <button
          type="button"
          className="read-more-less-btn"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};

const AllLeaveRequests = () => {
  const getUserRole = GetLoginRole();
  const [showRejectModal, setShowRejectModal] = useState("");
  const [showApproveModal, setShowApproveModal] = useState("");
  const [leaveApprovalDuplicate, setLeaveApprovalDuplicate] = useState([]);
  const [showSidebar, setShowSidebar] = useState(true);
  const [alldata, setalldata] = useState([]);
  const [rejectLeave, setRejectLeave] = useState("");
  const [rejectReasonLength, setRejectReasonLength] = useState(100);
  const [loading, setLoading] = useState(false);
  const [searchFilter, setSearchFilter] = useState("LeaveTypes");

  const LoginToken = GetToken();

  const handleDataSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    if (!searchTerm) {
      setalldata(leaveApprovalDuplicate);
      return;
    }

    const filteredData = leaveApprovalDuplicate.filter((item) => {
      if (searchFilter === "LeaveTypes") {
        return item?.LeaveTypes?.Name?.toLowerCase()?.includes(searchTerm);
      }

      if (searchFilter === "Status") {
        return item?.Status?.toLowerCase()?.includes(searchTerm);
      }

      return false;
    });

    setalldata(filteredData);
  };

  const GetLeavesApproval = () => {
    setLoading(true);

    const option = {
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };

    axios(option)
      .then((response) => {
        let data = response?.data?.data;

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (error) {
            toast.error("Parsing error");
            data = [];
          }
        }

        setLeaveApprovalDuplicate(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
        setLeaveApprovalDuplicate([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    GetLeavesApproval();
  }, []);

  useEffect(() => {
    setalldata(leaveApprovalDuplicate);
  }, [leaveApprovalDuplicate]);

  const handleApproveLeave = () => {
    setLoading(true);
    const data = {};
    data.Id = showApproveModal;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/ApproveLeave`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowApproveModal("");
          GetLeavesApproval();
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
        setLoading(false);
      });
  };

  const handleRejectLeave = () => {
    setLoading(true);

    if (!rejectLeave || rejectLeave.trim() === "") {
      toast.error("Please enter Reason");
      setLoading(false);
      return;
    }

    const data = {};
    data.Id = showRejectModal;
    data.RejectionReason = rejectLeave;

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/RejectLeave`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowRejectModal("");
          setRejectLeave("");
          GetLeavesApproval();
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const getStatusClassName = (status) => {
    if (status === "Cancelled") {
      return "EMP-Leaves-table-Rejected-button-by-admin";
    }

    if (status === "RejectedByHR" || status === "RejectedByAdmin") {
      return "EMP-Leaves-status-rejected";
    }

    if (status === "ApprovedByAdmin") {
      return "EMP-Leaves-status-approved-admin";
    }

    if (
      status === "ApprovedByHR" ||
      status === "YetToBeApprovedByAdmin"
    ) {
      return "EMP-Leaves-status-pending-admin";
    }

    if (
      status === "YetToBeApprovedByHR" ||
      status === "YetToBeApprovedByTeamLead"
    ) {
      return "EMP-YetToBeApprovedByTeamLead-button";
    }

    return "EMP-Leaves-table-Approved-button";
  };

  const getStatusLabel = (status) => {
    if (status === "YetToBeApprovedByHR") return "Pending At HR";
    if (status === "RejectedByHR") return "Rejected By HR";
    if (status === "ApprovedByHR") return "Pending At Admin";
    if (status === "ApprovedByAdmin") return "Approved By Admin";
    if (status === "RejectedByAdmin") return "Rejected By Admin";
    if (status === "YetToBeApprovedByAdmin") return "Pending At Admin";
    return status;
  };

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-Attendance-management"
              : "main-container-of-all-employees-page-new-Attendance-management"
          }
        >
          <div className="inner-container-of-all-employees-page-management">
            <div className="header-of-employees-page-management row">
              <div className="all-employee-Attendance-management col">
                <h4>Leave Requests</h4>
              </div>

              <div className="all-employees-Attendance-management col">
                <div className="home-icon-Attendance-management">
                  <BiHomeAlt className="home-icon-header-Attendance-management" />
                </div>
                <div className="arrow-icon-Attendance-management">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-Attendance-management">
                  <p>Leave</p>
                </div>
                <div className="arrow-icon-Attendance-management">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-Attendance-management">
                  <p>Leave Requests</p>
                </div>
              </div>
            </div>
          </div>

          <div className="body-part-outer-Attendance-management">
            <div className="inner-body-container-of-employee-Attendance-management row-12">
              <div className="first-side-in-body-Attendance-management col-6">
                <div className="employee-text-in-Attendance-management">
                  <h2>Leave Requests</h2>
                </div>

                <div className="search-container-leave-management">
                  <select
                    className="search-filter-dropdown"
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                  >
                    <option value="LeaveTypes">Leave Type</option>
                    <option value="Status">Status</option>
                  </select>

                  <div className="search-input-wrapper-leave">
                    <MdSearch className="search-icon-in-Attendance-management" />
                    <input
                      type="text"
                      placeholder={`Search by ${
                        searchFilter === "LeaveTypes" ? "Leave Type" : "Status"
                      }`}
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="table-in-all-emplyee-Attendance-management">
              <table className="table-main-Attendance-management">
                <thead className="thead-main-Attendance-management">
                  <tr>
                    <th className="image-class-management">Sr.No</th>
                    <th className="image-class-management">Image</th>
                    <th className="image-class-management">Name</th>
                    <th className="image-class-management">Leave Type</th>
                    <th className="image-class-management">Leave From</th>
                    <th className="image-class-management">Leave To</th>
                    <th className="image-class-management">No Of Days</th>
                    <th className="image-class-management">Status</th>
                    <th className="image-class-management">Approval Reason</th>
                    <th className="image-class-management">Action</th>
                  </tr>
                </thead>

                <tbody className="tbody-main-Attendance-management">
                  {alldata?.length ? (
                    <>
                      {alldata
                        ?.sort((a, b) =>
                          a?.User?.UserName?.toLowerCase() >
                          b?.User?.UserName?.toLowerCase()
                            ? 1
                            : -1
                        )
                        ?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>
                              {item?.imageUrl ? (
                                <img
                                  className="image-of-header"
                                  src={item.imageUrl || "/placeholder.svg"}
                                  onError={(e) => (e.target.src = dummyimage)}
                                  alt="not-available"
                                />
                              ) : (
                                <img
                                  src={dummyimage || "/placeholder.svg"}
                                  alt="not-available"
                                  className="profile-icon-header"
                                />
                              )}
                            </td>

                            <td>{item?.User?.UserName}</td>
                            <td>{item?.LeaveTypes?.Name}</td>

                            <td>{moment(item?.StartDate).format("DD MMM YYYY")}</td>
                            <td>{moment(item?.EndDate).format("DD MMM YYYY")}</td>
                            <td>{formatNoOfDays(item?.NumberofDays)}</td>

                            <td>
                              <button className={getStatusClassName(item?.Status)}>
                                {getStatusLabel(item?.Status)}
                              </button>
                            </td>

                            <td>
                              <ReadMoreText text={item?.Reason} maxLength={45} />
                            </td>

                            <td>
                              <div
                                className="button_approve_leave"
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  alignItems: "center",
                                }}
                              >
                                {getUserRole === "HR" ? (
                                  <>
                                    {item?.Status === "ApprovedByTeamLead" ? (
                                      <>
                                        <button
                                          className="EMP-Approve-table-Approved-button"
                                          onClick={() => setShowApproveModal(item?.Id)}
                                        >
                                          Approve
                                        </button>
                                        <button
                                          className="EMP-Approve-table-Rejected-button"
                                          onClick={() => setShowRejectModal(item?.Id)}
                                        >
                                          Reject
                                        </button>
                                      </>
                                    ) : (
                                      <div className="empty_leave_approval">-</div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {item?.Status === "YetToBeApprovedByTeamLead" ||
                                    item?.Status === "YetToBeApprovedByHR" ? (
                                      <>
                                        <button
                                          className="EMP-Approve-table-Approved-button"
                                          onClick={() => setShowApproveModal(item?.Id)}
                                        >
                                          Approve
                                        </button>
                                        <button
                                          className="EMP-Approve-table-Rejected-button"
                                          onClick={() => setShowRejectModal(item?.Id)}
                                        >
                                          Reject
                                        </button>
                                      </>
                                    ) : (
                                      <div className="empty_leave_approval"></div>
                                    )}
                                  </>
                                )}

                                {item?.LeaveTypes?.Name === "Sick Leave" &&
                                  (() => {
                                    const medicalDocs =
                                      item?.LeaveDocument ||
                                      item?.leaveDocument ||
                                      item?.MedicalDocuments ||
                                      item?.medicalDocuments ||
                                      [];

                                    return medicalDocs && medicalDocs.length > 0 ? (
                                      <>
                                        {medicalDocs.map((doc, docIndex) => {
                                          const fileUrl = doc?.FilePath || doc;
                                          return (
                                            <div
                                              key={docIndex}
                                              style={{
                                                display: "flex",
                                                gap: "5px",
                                                alignItems: "center",
                                              }}
                                            >
                                              <MdPreview
                                                title={`Preview Medical Bill ${
                                                  docIndex + 1
                                                }`}
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "18px",
                                                }}
                                                onClick={() =>
                                                  window.open(`${fileUrl}`, "_blank")
                                                }
                                              />
                                              <HiDownload
                                                title={`Download Medical Bill ${
                                                  docIndex + 1
                                                }`}
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "18px",
                                                }}
                                                onClick={() =>
                                                  window.open(`${fileUrl}`, "_blank")
                                                }
                                              />
                                            </div>
                                          );
                                        })}
                                      </>
                                    ) : null;
                                  })()}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  ) : (
                    <tr className="no-record-found-tr-dashboard">
                      <td colSpan="10">No record found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {showApproveModal && (
        <div className="modal show edit-leaveModal" style={{ display: "block" }}>
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowApproveModal("")}
            >
              <Modal.Title>Approve Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowApproveModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={handleApproveLeave}
              >
                Approve
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}

      {showRejectModal && (
        <div className="modal show edit-leaveModal" style={{ display: "block" }}>
          <Modal.Dialog>
            <Modal.Header
              className="delete-modal-header"
              closeButton
              onClick={() => setShowRejectModal("")}
            >
              <Modal.Title>Reject Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="textarea-validate">
                <label htmlFor="">Reason</label>
                <textarea
                  type="text"
                  className="textarea-for-delete-leave-api"
                  maxLength={100}
                  value={rejectLeave}
                  onChange={(e) => setRejectLeave(e?.target?.value)}
                />
                {rejectLeave ? (
                  <div className="character_left_leave_approval">
                    {rejectReasonLength - rejectLeave?.length} characters left
                  </div>
                ) : (
                  <div className="character_left_leave_approval">
                    100 characters left
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="Delete-fotter">
              <button
                className="Delete-modal-close-button"
                onClick={() => setShowRejectModal("")}
              >
                Close
              </button>
              <button
                className="Delete-modal-delete-button"
                onClick={handleRejectLeave}
              >
                Reject
              </button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      )}
    </>
  );
};

export default AllLeaveRequests;